import { DateTime } from 'luxon';
import { ListButton } from '../../../../../../components/Buttons/ListButton';
import { ContainerListPage } from '../../../../../../components/List/styles';
import { PQFLVisitRow } from '../../page';

type TableProps = {
  rows: PQFLVisitRow[];
  setSelectedRow: (row: PQFLVisitRow | null) => void;
  setModalType: (type: 'visualize' | 'print' | null) => void;
};

export const formatISODate = (date: string | null) => {
  if (!date) return '-';
  const dateWithoutZ = date.replace('Z', '');
  return DateTime.fromISO(dateWithoutZ).toFormat('dd/MM/yyyy HH:mm');
};

export const Table = ({ rows, setSelectedRow, setModalType }: TableProps) => {
  const handleAction = (row: PQFLVisitRow, type: 'visualize' | 'print') => {
    setSelectedRow(row);
    setModalType(type);
  };

  return (
    <ContainerListPage>
      <table>
        <thead>
          <tr>
            <th className="first-table-th">Código</th>
            <th className="list-td-large">Propriedade</th>
            <th className="list-td-large">Produtor</th>
            <th className="list-td-medium">Responsável</th>
            <th className="list-th">Status</th>
            <th className="list-td-medium">Início</th>
            <th className="list-td-medium">Fim</th>
            <th className="list-td-medium">Opções</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr
              key={index}
              onClick={() => handleAction(row, 'visualize')}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            >
              <td>{row.id}</td>
              <td>{row.propriedade.nome_propriedade}</td>
              <td>{row.propriedade.nome_produtor}</td>
              <td>{row.funcionario.nome}</td>
              <td>{row.status}</td>
              <td>{formatISODate(row.data_inicio)}</td>
              <td>{formatISODate(row.data_final)}</td>
              <td className="list-td-small">
                <div>
                  <ListButton
                    action={async (e: any) => {
                      e.stopPropagation();
                      handleAction(row, 'print');
                    }}
                    icon={'print'}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </ContainerListPage>
  );
};
